<template>
  <div class="t-app__container">
    <heading :title="$t('forgot-password-title')" />
    <div class="h-section h-section--no-margin-top">
      <div class="h-grid h-grid--justify-content-center">
        <div class="h-grid__col h-grid__col--sm-10 h-grid__col--md-8">
          <template v-if="emailSent">
            <div class="m-form-group--center">
              <p v-html="$t('forgot-password-email-sent-text', { email: `${email}` })"></p>
              <router-link :to="{ name: $consts.urls.URL_ACCOUNT_LOGIN }">
                {{ $t('return-btn') }}
              </router-link>
            </div>
          </template>
          <template v-else>
            <s-form @submit="sendEmail">
              <p class="form-group">
                <label class="a-form-label" for="email" :value="email">{{ $t('forgot-password-email-label') }}</label>
                <input class="a-form-control" :value="email" @change="setEmail($event.target.value)" :placeholder="$t('forgot-password-email-placeholder')" id="email" />
                <span v-if="$v.email.$dirty">
                  <span class="m-form-group__error" v-if="!$v.email.required">{{ $t('error-field-required') }}</span>
                  <span class="m-form-group__error" v-if="!$v.email.email">{{ $t('error-field-not-email') }}</span>
                </span>
              </p>
              <div class="m-form-ctrl">
                <div class="m-form-ctrl__item">
                  <button class="a-btn-primary" type="submit">
                    {{ $t('forgot-password-submit-btn') }}
                  </button>
                </div>
                <div class="m-form-ctrl__item">
                  <router-link :to="{ name: $consts.urls.URL_ACCOUNT_LOGIN }">
                    {{ $t('return-btn') }}
                  </router-link>
                </div>
              </div>
            </s-form>
          </template>
        </div>
      </div>
    </div>

    <div class="t-app__confetti t-app__confetti--01"></div>
    <div class="t-app__dot t-app__dot--large"></div>
    <div class="t-app__confetti t-app__confetti--02"></div>
    <div class="t-app__confetti t-app__confetti--03"></div>
    <div class="t-app__confetti t-app__confetti--04"></div>
    <div class="t-app__dot t-app__dot--medium"></div>
    <div class="t-app__confetti t-app__confetti--05"></div>
  </div>
</template>

<script>
import { required, email } from 'vuelidate/lib/validators'

import SForm from '@/components/form/form'
import Heading from '@/components/heading'

import UserService from '@/services/user'
import Notification from '@/services/notification'
import LoaderService from '@/services/loader'

import i18n from '@/helpers/i18n'

export default {
  data() {
    return {
      emailSent: false,
      email: ''
    }
  },
  validations: {
    email: {
      required,
      email
    }
  },
  components: {
    SForm,
    Heading
  },
  methods: {
    sendEmail: async function () {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        LoaderService.showLoader()
        try {
          let result = await UserService.sendPasswordReset(this.email)
          if (result.status === 500) {
            Notification.showError(i18n.t('error-basic'))
          } else {
            this.emailSent = true
          }
        } finally {
          LoaderService.hideLoader()
        }
      }
    },
    setEmail: function (value) {
      this.email = value
      this.$v.email.$touch()
    }
  }
}
</script>
